import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { AppStoreBadges } from "./AppStoreBadges";
import { PAGES } from "@/constants/testIds";
import { WEB_REGISTER_URL } from "@/constants/site";
import { captureEvent } from "@/lib/analytics";

export const PageBottomCTA = ({
  eyebrow = "Ready to begin",
  title = "Start with one real transaction. Build from the truth.",
  body = "Create the workspace, capture the work as it happens, and give every next decision a reliable starting point.",
  primaryLabel = "Start my free trial",
  primaryTo = WEB_REGISTER_URL,
}) => (
  <section className="relative overflow-hidden bg-[#0A3B3B] text-white py-20 md:py-28">
    <div className="absolute inset-0 bg-kente opacity-[0.10] pointer-events-none" />
    <div className="absolute -top-32 -left-20 h-[400px] w-[400px] rounded-full bg-[#0E6B6B]/40 blur-3xl pointer-events-none" />
    <div className="absolute -bottom-32 right-0 h-[380px] w-[380px] rounded-full bg-[#D96C4A]/20 blur-3xl pointer-events-none" />

    <div className="relative mx-auto max-w-7xl px-6 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-8 items-end">
        <div className="lg:col-span-8">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#FFD8A8]">{eyebrow}</span>
          <h2 className="mt-4 font-display text-3xl md:text-4xl lg:text-5xl font-semibold leading-[1.1] tracking-tight">
            {title}
          </h2>
          <p className="mt-5 text-base md:text-lg text-white/80 max-w-2xl">{body}</p>
        </div>
        <div className="lg:col-span-4 flex flex-col items-start lg:items-end gap-4">
          <Link
            to={primaryTo}
            target={primaryTo.startsWith("http") ? "_blank" : undefined}
            rel={primaryTo.startsWith("http") ? "noreferrer" : undefined}
            data-testid={PAGES.pageBottomCta}
            onClick={() => captureEvent("conversion_cta_clicked", { placement: "page_bottom", destination: primaryTo === WEB_REGISTER_URL ? "web_register" : primaryTo })}
            className="inline-flex items-center gap-2 rounded-full bg-[#FFD8A8] text-[#0A2424] px-6 py-3.5 text-base font-semibold hover:bg-white transition-colors"
          >
            {primaryLabel} <ArrowRight className="h-4 w-4" />
          </Link>
          <AppStoreBadges
            playId="bottom-cta-google-play"
            storeId="bottom-cta-app-store"
            placement="page_bottom"
          />
        </div>
      </div>
    </div>
  </section>
);

export default PageBottomCTA;
